import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

export default withTranslation()(function CreateHeader({ t, onClose }) {
  return (
    <header className="relative flex items-center justify-center h-[74px] border-b border-border-lines px-4 shrink-0">
      <button
        type="button"
        onClick={onClose}
        className="absolute left-4 w-9 h-9 flex items-center justify-center rounded-full hover:bg-background"
      >
        <UIcons.UilTimes size={20} className="text-dark-blue" />
      </button>

      <h1 className="text-lg font-semibold text-dark-blue">{t('rewardAds.create')}</h1>
    </header>
  )
})
